var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceptionDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 3.33335C11.6666 4.25383 10.9204 5.00002 9.99992 5.00002C9.07942 5.00002 8.33325 4.25383 8.33325 3.33335C8.33325 2.41288 9.07942 1.66669 9.99992 1.66669C10.9204 1.66669 11.6666 2.41288 11.6666 3.33335Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10.4166C13.3334 8.84531 13.3334 8.05962 12.8452 7.57147C12.3571 7.08331 11.5714 7.08331 10.0001 7.08331C8.42875 7.08331 7.64306 7.08331 7.15491 7.57147C6.66675 8.05962 6.66675 8.84531 6.66675 10.4166V11.6666C6.66675 12.4523 6.66675 12.8451 6.91082 13.0892C7.15491 13.3333 7.54774 13.3333 8.33341 13.3333V16.6666C8.33341 17.4523 8.33341 17.8451 8.5775 18.0892C8.82158 18.3333 9.21441 18.3333 10.0001 18.3333C10.7857 18.3333 11.1786 18.3333 11.4227 18.0892C11.6667 17.8451 11.6667 17.4523 11.6667 16.6666V13.3333C12.4524 13.3333 12.8452 13.3333 13.0893 13.0892C13.3334 12.8451 13.3334 12.4523 13.3334 11.6666V10.4166Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptionDesk);
export default __webpack_public_path__ + "static/media/reception-desk.08f4add7dede753e90da415c5d13037c.svg";
export { ForwardRef as ReactComponent };